import {Component, OnInit} from "@angular/core";
import {UntypedFormControl, UntypedFormGroup, Validators,} from '@angular/forms';
import {Router} from "@angular/router";
import {shopDetails} from "@pages/modal/shopdetails";
import {VendorOrderDetails} from "@pages/modal/vendorOrderDetails";
import {AppService} from "@services/app.service";
import {NgxSpinnerService} from "ngx-spinner";
import {Subject, takeUntil} from "rxjs";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";
import {PrintDataService} from "@services/printDataService";
import {OrderDetails} from "@pages/modal/order/OrderDetails";
import {allShopProductDetails} from "@pages/modal/allShopProductDetails";
import {Order} from "@pages/modal/order/Order";
import {DistributorOrderDetails} from "@pages/modal/order/DistributorOrderDetails";
import {DatePipe} from "@angular/common";
import {AddressDetails} from "@pages/modal/order/AddressDetails";


@Component({
    selector: 'order-processing',
    templateUrl: './order-processing.component.html',
    styleUrls: ['./order-processing.component.scss']
})

export class OrderProcessingComponent implements OnInit {
    searchText;
    destroy$: Subject<boolean> = new Subject<boolean>();
    shopId: number = 0;
    showShopName: String[] = [];
    orderList: VendorOrderDetails[] = [];
    orderDetails: OrderDetails[] = [];
    itemsDetails: allShopProductDetails[] = [];
    items: String[] = [];
    orderPlacedList: VendorOrderDetails[] = [];
    orderAcceptedList: VendorOrderDetails[] = [];
    orderPickupList: VendorOrderDetails[] = [];
    orderClosedList: VendorOrderDetails[] = [];
    modalShowData: VendorOrderDetails[] = [];
    orderItemList: VendorOrderDetails[] = [];
    orderId: number;
    orderUID: string;
    currentOrderId: number = 0;
    totalAmount: number = 0;
    discount: string = "";
    taxableAmount: string = "";
    chargeableAmount: string = "";
    payableAmount: number = 0;
    shopList: shopDetails[] = [];
    localShopList: shopDetails[] = [];
    orderPlacedCount: number = 0;
    orderAcceptedCount: number = 0;
    orderPickupCount: number = 0;
    orderDeliveryCount: number = 0;
    orderClosedCount: number = 0;
    isVisible = false;
    isVisibleCancel = false;
    orderPlacedShow = true;
    orderAcceptedShow = true;
    orderReadyShow = false;
    orderDeliveryShow: boolean = false;
    orderCloseShow = false;
    isAccepted = false;
    isReady = false;
    isDelivery = false;
    isClosed = false;
    isClosedStatus = false;
    isCanceled = false;
    isCancel = false;
    isPaid = false;
    isNotPaid = false;
    retailerOrderDetails: DistributorOrderDetails[] = [];
    superAdminOrderDetails: Order[] = [];
    retailerBasedOrder: Order[] = [];
    retailerAcceptedOrder: Order[] = [];
    retailerPickupOrder: Order[] = [];
    retailerDeliveryOrder: Order[] = [];
    retailerDeliveredOrder: Order[] = [];
    modalProductShow: Order | undefined;
    productList: OrderDetails[] = [];
    deliveryDateShow = false;
    selectedDate: string;
    buttonStatus: string;
    shopName: string;
    isDisabled = false;
    isEnabled = false;
    appCode: string;
    minDate: string | null;
    activeTab: string = 'accepted';
    totalTaxAmount: number = 0;
    paymentStatus: string = "";

    constructor(
        private router: Router, private appService: AppService,
        private spinner: NgxSpinnerService, private toaster: ToastrService,
        private dataService: PrintDataService,
        private datePipe: DatePipe
    ) {
        this.minDate = this.datePipe.transform(new Date(), 'YYYY-MM-dd');
    }

    orderProcessing = new UntypedFormGroup({
        orderStatus: new UntypedFormControl("", Validators.required),
        reasonForCancel: new UntypedFormControl("", Validators.required),
        orderId: new UntypedFormControl("", Validators.required)
    });

    ngOnInit(): void {
        this.appCode = localStorage.getItem('appCode');
        this.getShopDetails();
        if (localStorage.getItem('userType') == "SUPERADMIN") {
            this.getAllOrderDetailsBySuperAdmin();
        } else {
            this.getAllOrderDetailsByDistributor();
        }
    }

    setActiveTab(tab: string): void {
        this.activeTab = tab;
    }


    getOrderStatus(orderType: string): string {
        switch (orderType) {
            case 'CUSTOMER PICKUP':
                return 'Customer Pickup';

            case 'DOOR DELIVERY':
                return 'Door Delivery';

            default:
                return 'Unknown Order Type';
        }
    }

    getFormattedAddress(addressDetails: AddressDetails): string {
        const address = addressDetails;

        if (!address) return '';

        const area = address.area || '';
        const city = address.city || '';
        const state = address.state || '';

        return [area, city, state].filter(Boolean).join(', ');
    }


    // New order based notification sound alert
    orderNotification() {
        let audio = new Audio();
        audio.src = "assets/audio/Waterdrop_Drop.mp3"
        audio.load();
        audio.play();
    }

    close() {
        this.isVisibleCancel = true;
    }

    closeModal() {
        this.isVisibleCancel = false;
    }

    closeAlert() {
        this.isVisible = false;
        this.selectedDate = "";
        this.isDisabled = false;
    }

    getPayableAmount(listOrderDetails: OrderDetails[]): number {
        const totalAmountList = listOrderDetails.map(item => item.totalAmount);
        return totalAmountList.reduce((acc, value) => acc + value, 0);
    }

    calculateTax(order: OrderDetails): number {
        const gstPercentage = order.cgst + order.sgst;
        const amount = order.itemSRP;
        const taxInRupees = (amount * gstPercentage) / 100 * order.itemCount;
        this.totalTaxAmount = taxInRupees + order.itemSRP;

        this.payableAmount = this.productList.reduce((total, order) => {
            const gstPercentage = order.cgst + order.sgst;
            const amountWithTax = order.itemSRP * (1 + gstPercentage / 100);
            const totalForItem = amountWithTax * order.itemCount;
            return total + totalForItem;
        }, 0);
        return taxInRupees;
    }

    orderAccepted() {
        console.log("Hide:", this.orderPlacedShow)
        this.orderAcceptedShow = true;
        this.orderReadyShow = false;
        this.orderCloseShow = false;
        this.orderPlacedShow = false;
        this.orderDeliveryShow = false;
    }

    orderReady() {
        this.orderReadyShow = true;
        this.orderCloseShow = false;
        this.orderAcceptedShow = false;
        this.orderPlacedShow = false;
        this.orderDeliveryShow = false;
    }

    orderDelivery() {
        this.orderDeliveryShow = true;
        this.orderAcceptedShow = false;
        this.orderReadyShow = false;
        this.orderCloseShow = false;
        this.orderPlacedShow = false;
    }

    orderClosed() {
        this.orderCloseShow = true;
        this.orderReadyShow = false;
        this.orderAcceptedShow = false;
        this.orderPlacedShow = false;
        this.orderDeliveryShow = false;
    }

    orderStatus(event: any) {
        this.buttonStatus = event.target.innerText;
        console.log("status::", this.buttonStatus);
        console.log("DD::", this.selectedDate);
        let dateObject: Date = new Date(this.selectedDate);
        let deliveryDate: number = dateObject.getTime();
        console.log("Epoch value:", deliveryDate);
        console.log("current OID::", this.currentOrderId)

        if (this.buttonStatus == "Accepted") {
            this.appService
                .deliverDateUpdate(this.currentOrderId, deliveryDate)
                .pipe(takeUntil(this.destroy$))
                .subscribe((data) => {
                    console.log("Update DD::", data);
                    this.toaster.success("Delivery Date Updated", this.selectedDate)
                }, (error: any) => {
                    this.toaster.error("Delivery Date Not Update.Please try again")
                })
            this.updateOrderStatus();
        } else {
            this.updateOrderStatus();
        }
    }

    updateOrderStatus() {
        if (
            this.modalProductShow.orderStatus !== 'Accepted' &&
            this.modalProductShow.paymentStatus !== 'Paid' &&
            this.paymentStatus === ''
        ) {
            console.log(this.modalProductShow.orderStatus);
            this.toaster.info(`Please update payment status`);
            return;
        }

        this.spinner.show();
        this.appService
            .orderStatusUpdate(this.currentOrderId, this.buttonStatus)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (data) => {
                    console.log("Update OD::", data);

                    if (this.buttonStatus === 'Delivered' && this.modalProductShow.paymentStatus === 'Not Paid') {
                        this.updatePaymentStatus();
                    } else {
                        this.isVisible = false;
                        this.spinner.hide();
                        this.toaster.success("Order Status Updated", this.buttonStatus);
                    }

                    const userType = localStorage.getItem('userType');
                    if (userType === "SUPERADMIN") {
                        this.getAllOrderDetailsBySuperAdmin();
                    } else {
                        this.getAllOrderDetailsByDistributor();
                    }
                },
                (error: any) => {
                    this.spinner.hide();
                    this.toaster.error("Order Status Not Updated. Please try again");
                }
            );
    }

    updatePaymentStatus() {
        console.log(this.paymentStatus);
        this.spinner.show();
        this.appService
            .paymentStatusUpdate(this.currentOrderId, this.paymentStatus)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                console.log("Update OD::", data);
                this.spinner.hide();
                this.toaster.success("Order & Payment Status Updated Successfully.");
                this.isVisible = false;
                this.paymentStatus = "";
                if (localStorage.getItem('userType') == "SUPERADMIN") {
                    this.getAllOrderDetailsBySuperAdmin();
                } else {
                    this.getAllOrderDetailsByDistributor();
                }
            }, (error: any) => {
                this.spinner.hide();
                this.toaster.error("Order Status Not Update.Please try again")
            })
    }

    invoicePrint(orderId) {
        localStorage.setItem('orderId', orderId);
        this.router.navigate(['/invoice-print']);
    }

    getShopDetails() {
        this.appService.getShopDetails()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                    console.log("Shop Details::", data);
                    this.shopList = data;
                },
                (error: any) => {
                    this.spinner.hide();
                    this.toaster.error("Something went wrong for get Shop Details")
                })
    }

    selectShopOrders(event) {
        const value = event.target.value;
        /* this.getOrderData();*/
    }

    /*getOrderData() {
        this.spinner.show();
        this.appService.getVendorOrders(this.shopId)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                console.log("Order Details::", data)
                //@ts-ignore
                this.orderList = data;
                for (let order of this.orderList) {
                    this.orderDetails = order.listOrderDetails
                    for (let item of this.orderDetails) {
                        console.log("item name::", item.itemName)
                        // @ts-ignore
                        this.itemsDetails.push(item.shopProductID);
                    }
                }
                this.tableData();
            })
    }*/

    tableData() {
        var ordersPlaceList: VendorOrderDetails[] = [];
        var ordersAcceptList: VendorOrderDetails[] = [];
        var ordersReadyList: VendorOrderDetails[] = [];
        var ordersCloseList: VendorOrderDetails[] = [];
        for (let order of this.orderList) {
            if (order.orderStatus == "Ordered") {
                ordersPlaceList.push(order)
            }
            this.orderPlacedList = ordersPlaceList.sort((a, b) => b.orderId - a.orderId);
            console.log("order Placed list::", this.orderPlacedList)
            this.orderPlacedCount = this.orderPlacedList.length;

            if (order.orderStatus == "Accepted") {
                ordersAcceptList.push(order)
            }
            this.orderAcceptedList = ordersAcceptList.sort((a, b) => b.orderId - a.orderId);
            console.log("order Accepted list::", this.orderAcceptedList)
            this.orderAcceptedCount = this.orderAcceptedList.length;

            if (order.orderStatus == "Ready") {
                ordersReadyList.push(order)
            }
            this.orderPickupList = ordersReadyList.sort((a, b) => b.orderId - a.orderId);
            console.log("order Pickup list::", this.orderPickupList)
            this.orderPickupCount = this.orderPickupList.length;

            if (order.orderStatus == "Closed" || order.orderStatus == "Cancelled") {
                ordersCloseList.push(order)
            }
            this.orderClosedList = ordersCloseList.sort((a, b) => b.orderId - a.orderId);
            console.log("order Closed list::", this.orderClosedList)
            this.orderClosedCount = this.orderClosedList.length;
        }
        this.spinner.hide();
        const orderCount = localStorage.getItem('Order Count');
        // @ts-ignore
        if (orderCount < this.orderPlacedCount) {
            this.orderNotification();
        }
        localStorage.removeItem('Order Count')
        localStorage.setItem('Order Count', String(this.orderPlacedCount))
    }

    /*updateOrderStatus() {
        console.log("Update Order Status::", this.orderProcessing.value)
        this.spinner.show();
        this.appService
            .updateOrderStatus(this.orderProcessing.value)
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                console.log("Update Order Status::", data)
                this.isVisibleCancel = false;
                this.spinner.hide();
                this.toaster.success("Order Status Updated Successfully")
             /!*   this.getOrderData();*!/
                this.isVisible = false;
            }, (error: any) => {
                this.isVisibleCancel = false;
                this.spinner.hide();
                this.toaster.error("Something went wrong, Please try Again")
            })

    }*/


    //Get all Order details from Distributor ID.
    getAllOrderDetailsByDistributor() {
        this.spinner.show();
        this.appService
            .getOrderDetailsByDistributor()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                this.spinner.hide();
                console.log("Get Retailer Orders::", data);
                this.retailerOrderDetails = data;
                this.getOrderedDetails();
            }, (error: any) => {
                this.spinner.hide();
                this.toaster.error("No Orders Found. Please try again later");
            })
    }

    //Get all Order details from SUPERADMIN
    getAllOrderDetailsBySuperAdmin() {
        this.spinner.show();
        this.appService
            .getOrderDetailsBySuperAdmin()
            .pipe(takeUntil(this.destroy$))
            .subscribe((data) => {
                this.spinner.hide();
                console.log("Get Retailer Orders::", data);
                this.superAdminOrderDetails = data.filter(item => item.appCode != "ANANDHAM");
                this.getOrderedDetails();
            }, (error: any) => {
                this.spinner.hide();
                this.toaster.error("No Orders Found. Please try again later");
            })
    }

    //Get Ordered Status Details
    getOrderedDetails() {
        var orderDetail: Order[] = [];
        if (localStorage.getItem('userType') == "SUPERADMIN") {
            orderDetail = this.superAdminOrderDetails;
        } else {
            for (let order of this.retailerOrderDetails) {
                orderDetail = orderDetail.concat([...order.order]);
            }
        }
        console.log("order Details::", orderDetail)

        this.retailerBasedOrder = orderDetail.filter(item => item.orderStatus == "Ordered").sort((a, b) => b.orderId - a.orderId);
        this.orderPlacedCount = this.retailerBasedOrder.length;

        this.retailerAcceptedOrder = orderDetail.filter(item => item.orderStatus == "Accepted").sort((a, b) => b.orderId - a.orderId);
        this.orderAcceptedCount = this.retailerAcceptedOrder.length;

        this.retailerPickupOrder = orderDetail.filter(item => item.orderStatus == "Ready For Pickup" && item.orderType == 'CUSTOMER PICKUP').sort((a, b) => b.orderId - a.orderId);
        this.orderPickupCount = this.retailerPickupOrder.length;

        this.retailerDeliveryOrder = orderDetail.filter(item => item.orderStatus == "Ready For Delivery" && item.orderType == 'DOOR DELIVERY').sort((a, b) => b.orderId - a.orderId);
        this.orderDeliveryCount = this.retailerDeliveryOrder.length;

        this.retailerDeliveredOrder = orderDetail.filter(item => item.orderStatus == "Delivered").sort((a, b) => b.orderId - a.orderId);
        this.orderClosedCount = this.retailerDeliveredOrder.length;

        for (let address of this.retailerBasedOrder) {
            let dateObject: Date = new Date(address.deliveredDate);
            let formattedDate: string = dateObject.toLocaleDateString('en-GB');
            // this.deliveredDate = formattedDate;
        }
        /*for (let status of this.retailerBasedOrder) {
            if (status.paymentStatus == 'Paid') {
                this.isPaid = true;
            }
            if (status.paymentStatus == 'Not Paid') {
                this.isNotPaid = true;
            }
        }*/
    }

    orderProductModalShow(orderId, status: string, orderType) {
        console.log('status::', status)
        this.productList = [];
        this.currentOrderId = orderId;
        /* if (status == 'Ordered') {
             var orderProductList: OrderDetails[] = [];
             for (let ordered of this.retailerBasedOrder) {
                 if (ordered.orderId == this.currentOrderId) {
                     this.modalProductShow = ordered;
                     this.orderUID = this.modalProductShow.orderUID;
                     this.shopName = this.modalProductShow.createdBy
                     this.isVisible = true;
                     this.isAccepted = true;
                     this.isClosed = false;
                     this.deliveryDateShow = true;
                     for (let product of this.modalProductShow.listOrderDetails) {
                         orderProductList.push(product)
                     }
                 }
                 if (ordered.paymentStatus == 'Paid') {
                     this.isPaid = true;
                 }
                 if (ordered.paymentStatus == 'Not Paid') {
                     this.isNotPaid = true;
                 }
             }
             this.productList = orderProductList;
         } */
        if (status == 'Accepted') {
            var acceptedProductList: OrderDetails[] = [];
            for (let accepted of this.retailerAcceptedOrder) {
                if (accepted.orderId == this.currentOrderId) {
                    this.modalProductShow = accepted;
                    this.orderUID = this.modalProductShow.orderUID;
                    this.shopName = this.modalProductShow.createdBy
                    this.isVisible = true;
                    if (orderType == "CUSTOMER PICKUP") {
                        this.isReady = true;
                        this.isDelivery = false;
                    } else if (orderType == "DOOR DELIVERY") {
                        this.isDelivery = true;
                        this.isReady = false;
                    }
                    this.isClosed = false;
                    this.isAccepted = false;
                    this.deliveryDateShow = false;
                    for (let acceptedProduct of this.modalProductShow.listOrderDetails) {
                        acceptedProductList.push(acceptedProduct)
                    }
                }
                if (accepted.paymentStatus == 'Paid') {
                    this.isPaid = true;
                }
                if (accepted.paymentStatus == 'Not Paid') {
                    this.isNotPaid = true;
                }
            }
            this.productList = acceptedProductList;
        } else if (status == 'Ready For Pickup') {
            var pickupProductList: OrderDetails[] = [];
            for (let pickup of this.retailerPickupOrder) {
                if (pickup.orderId == this.currentOrderId) {
                    this.modalProductShow = pickup;
                    this.orderUID = this.modalProductShow.orderUID;
                    this.shopName = this.modalProductShow.createdBy
                    this.isVisible = true;
                    this.isReady = false;
                    this.isClosed = true;
                    this.isDelivery = false;
                    this.isAccepted = false;
                    this.deliveryDateShow = false;
                    for (let pickupProduct of this.modalProductShow.listOrderDetails) {
                        pickupProductList.push(pickupProduct)
                    }
                }
                if (pickup.paymentStatus == 'Paid') {
                    this.isPaid = true;
                }
                if (pickup.paymentStatus == 'Not Paid') {
                    this.isNotPaid = true;
                }
            }
            this.productList = pickupProductList;
        } else if (status === 'Ready For Delivery') {
            console.log('status::', status)
            var deliveryProductList: OrderDetails[] = [];
            for (let delivery of this.retailerDeliveryOrder) {
                if (delivery.orderId == this.currentOrderId) {
                    this.modalProductShow = delivery;
                    this.orderUID = this.modalProductShow.orderUID;
                    this.shopName = this.modalProductShow.createdBy
                    this.isVisible = true;
                    this.isClosed = true;
                    this.isReady = false;
                    this.isDelivery = false;
                    this.isAccepted = false;
                    this.deliveryDateShow = false;
                    for (let deliveryProduct of this.modalProductShow.listOrderDetails) {
                        deliveryProductList.push(deliveryProduct)
                    }
                }
                if (delivery.paymentStatus == 'Paid') {
                    this.isPaid = true;
                }
                if (delivery.paymentStatus == 'Not Paid') {
                    this.isNotPaid = true;
                }
            }
            this.productList = deliveryProductList;
        } else if (status == 'Delivered') {
            var deliveredProductList: OrderDetails[] = [];
            for (let delivered of this.retailerDeliveredOrder) {
                if (delivered.orderId == this.currentOrderId) {
                    this.modalProductShow = delivered;
                    this.orderUID = this.modalProductShow.orderUID;
                    this.shopName = this.modalProductShow.createdBy
                    this.isVisible = true;
                    this.isClosed = false;
                    this.isAccepted = false;
                    this.isDelivery = false;
                    this.deliveryDateShow = false;
                    for (let deliveredProduct of this.modalProductShow.listOrderDetails) {
                        deliveredProductList.push(deliveredProduct)
                    }
                }
                if (delivered.paymentStatus == 'Paid') {
                    this.isPaid = true;
                }
                if (delivered.paymentStatus == 'Not Paid') {
                    this.isNotPaid = true;
                }
            }
            this.productList = deliveredProductList;
        }


        var salePrice: number[] = [];
        for (let total of this.productList) {
            salePrice.push(Number(total.itemSRP * total.itemCount));
        }
        let sum: number = salePrice.reduce((acc, currentValue) => acc + currentValue, 0);
        this.totalAmount = sum;
        console.log("SRP::", salePrice)
        console.log("current product data::", this.modalProductShow);
        console.log("product data::", sum);
    }

    acceptShow(event) {
        console.log("value date::", event.target.value)
        const value = event.target.value;
        if (value != '') {
            this.isDisabled = true;
        } else {
            this.isDisabled = false;
        }
    }

    isPaymentStatusVisible(): boolean {
        const status = this.modalProductShow?.orderStatus;
        return status === 'Ready For Delivery' || status === 'Ready For Pickup';
    }


}
